export default [
	{ label: "Aktuelt", value: "" },
	{ label: "Pris lav-høy", value: "price:asc" },
	{ label: "Pris høy-lav", value: "price:desc" },
];
